<app-feature-hero
    variant="itsm"
    title="Self-Service Portal"
    description="Let users control their ITSM journeys with consolidated self-service features"
    image=""
    imageAlt=""
></app-feature-hero>


<section class="container section-spacing">
    <div class="row mx-0 align-items-center">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-left">
                <h2 class="section-title">Augment ITSM Productivity With Code-Free Self-Service</h2>
                <p class="section-paragraph">Infraon ITSM provides a top-notch self-service portal designed to automate critical ITSM processes – anytime, anywhere. Simplify your users’ lives by enabling them to receive fast and convenient self-service experiences.</p>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-img-right justify-content-center">
                <img src="/assets/img/feature-pages/infraon-itsm/self-service/Group21912.png" width="80%" alt="Infraon Knowledge Base">
            </div>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <div id="gdpr-wrapper">
        <div class="gdpr-section justify-content-center">
            <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100">
            <div>
                <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
                <p class="section-paragraph mb-0">We are compliant with the European General Data Protection Regulation (GDPR) – and <br> our SaaS-based product suite is fully committed to protecting the data of our customers <br> as per the recent standards.</p>
            </div>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <h2 class="section-title text-center p-b-60">Key Feature</h2>

    <div class="row mx-0 justify-content-center">
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-itsm/self-service/pencil.svg" alt="Pencil Icon">
            </div>
            <p class="section-title-s">Integrated Self-Resolution</p>
            <p class="section-paragraph-s">Let users be in control of their service lifecycles by giving them all the tools they need to raise requests, resolve incidents, ensure change management, etc.</p>
        </div>
        
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-itsm/self-service/disc.svg" alt="disc icon">
            </div>
            <p class="section-title-s">AI-Led Knowledge Base</p>
            <p class="section-paragraph-s">Decrease service delays by equipping users with easy access to a centralized knowledge base with AI-powered search capability.</p>
        </div>
        
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-itsm/self-service/navigation.svg" alt="navigation icon">
            </div>
            <p class="section-title-s">Deep-Dive Reporting</p>
            <p class="section-paragraph-s">Generate elaborate reports that contain macro & micro insights on user behavior & service patterns to keep IT teams on track.</p>
        </div>
    </div>
</section>


<section class="bg-grey">
    <div class="container section-spacing">
        <div class="row mx-0 d-flex align-items-center position-relative bg-black-dots">
            <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-xs-12 section-spacing">
                <h2 class="section-title">Other Features</h2>
    
                <div class="row mx-0 px-0">
                    <ul class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 px-0">
                        <li class="d-flex align-items-center my-3"><img class="me-3" src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon"> <p class="section-paragraph mb-0">Robust Portal UI</p></li>
                        <li class="d-flex align-items-center my-3"><img class="me-3" src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon"> <p class="section-paragraph mb-0">Chatbots</p></li>
                    </ul>
                    <ul class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 px-0">
                        <li class="d-flex align-items-center my-3"><img class="me-3" src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon"> <p class="section-paragraph mb-0">Service Content Discovery</p></li>
                        <li class="d-flex align-items-center my-3"><img class="me-3" src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon"> <p class="section-paragraph mb-0">Self-Service FAQs</p></li>
                    </ul>
                </div>
            </div>
    
            <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-xs-12 key-features-img-box d-flex justify-content-center position-absolute" style="right: 0;bottom: 0;">
                <img src="/assets/img/feature-pages/infraon-itsm/self-service/woman-1.webp" class="w-60" alt="woman point at features">
            </div>
        </div>
    </div>
</section>

<section class="section-spacing bg-grey">
    <div class="container" id="g2-box-wrapper">
        <div class="g2-box justify-content-between">
            <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo">
            <p>Already love using our products? Please <br> share your experiences on G2</p>
            <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button">Rate us</a>
        </div>
    </div>
</section>